module.exports = __webpack_public_path__ + "ptc_nakagawa_L2.544a727a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_L2.jpg
// module id = kkhV
// module chunks = 0